// extracted by mini-css-extract-plugin
export default {"dropArea":"DragAndDrop_dropArea__Y4FnY","dragOver":"DragAndDrop_dragOver__TijhL"};